<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div  id="data-list-list-view" class="data-list-container">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} {{$t('NotFound')}}. </span>
      <span>
        <span>{{$t('Check')}} </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card >

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs class="tab-action-btn-fill-conatiner">
          <vs-tab :label="$t('MainInfo')" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <add-edit-main class="mt-4" :instructorModel="instructorModel" :viewLoginInfo="false" />
            </div>
          </vs-tab>
          <vs-tab :label="$t('Contact')" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <add-edit-contact class="mt-4" :data="instructorModel" />
            </div>
          </vs-tab>
          <vs-tab :label="$t('Language')" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <add-edit-language class="mt-4" :data="instructorModel" />
            </div>
          </vs-tab>
            <vs-tab :label="$t('Education')" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <add-edit-education class="mt-4" :data="instructorModel" />
            </div>
          </vs-tab>
          <vs-tab :label="$t('CoursesToDeliver')" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <add-edit-course class="mt-4" :data="instructorModel" />
            </div>
          </vs-tab>

           <vs-tab :label="$t('CoursesObtained')" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <add-edit-obtain-course class="mt-4" :data="instructorModel" />
            </div>
          </vs-tab>

           <vs-tab :label="$t('Work')" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <add-edit-work class="mt-4" :data="instructorModel" />
            </div>
          </vs-tab>
           <vs-tab :label="$t('Attachments')" icon-pack="feather" icon="icon-share-2">
            <div class="tab-text">
              <add-edit-attachment class="mt-4" :data="instructorModel" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
     <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!isFormValid">{{$t('Submit')}} </vs-button>
          <vs-button class="ml-4 mt-2" type="border"  color="danger" @click="cancle">{{$t('Cancel')}}</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddEditMain       from "./Add-Edit-Main.vue"
import AddEditLanguage    from "./Add-Edit-Language.vue"
import AddEditContact    from "./Add-Edit-Contact.vue"
import AddEditEducation    from "./Add-Edit-Education.vue"
import AddEditCourse    from "./Add-Edit-Course.vue"
import AddEditObtainCourse    from "./Add-Edit-Obtain-Course.vue"
import AddEditWork    from "./Add-Edit-Work.vue"
import AddEditAttachment    from "./Add-Edit-Attachment.vue"

// Store Module
import moduleInstructor from "@/store/instructor/moduleInstructor.js";

export default {
  components: {
    AddEditMain,
    AddEditLanguage,
    AddEditContact,
    AddEditEducation,
    AddEditCourse,
    AddEditWork,
    AddEditAttachment,
    AddEditObtainCourse
  },
  computed:{
      isFormValid() {
      debugger;
      return !this.errors.any()&& this.instructorModel.Name&& this.instructorModel.CountryID>0
      &&this.instructorModel.NationalityID>0&&this.instructorModel.InstructorStatusID>0
      &&this.instructorModel.MaritalStatusID

    },
  },

  data() {
    return {

      instructorModel: {
        InstructorLanguages:[],
        InstructorContacts:[],
        InstructorEducations:[],
        InstructorCourses:[],
        InstructorAreas:[],
        InstructorIndustrySectors:[],
        Attachments:[],
      },

      user_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0,
    }
  },
  watch: {
    // activeTab() {
    //   this.fetch_instructor_data(this.$route.params.userId)
    // }
  },
  methods: {

reset_data() {
     this.initValues();
    },
    /* fetch_instructor_data(userId) {
      this.$store.dispatch("instructorList/fetchDataListItems", userId)
        .then(res => { this.instructorModel = res.data })
        .catch(err => {
          if(err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err) })
    }, */
    cancle(){
      this.$router.push('/Instructor');
    },
    save_changes() {
     debugger;
      this.$validator.validateAll().then(result => {
        if (result) {
          if(this.instructorModel.InstructorLanguages.length>0
            &&this.instructorModel.InstructorContacts.length>0
            &&this.instructorModel.InstructorEducations.length>0
            &&this.instructorModel.InstructorObtainCourses.length>0
            &&this.instructorModel.InstructorAreas.length>0
            &&this.instructorModel.InstructorIndustrySectors.length>0

            &&this.instructorModel.InstructorContacts.find(function(obj){ if(obj.ContactTypeID==4) return true; })
          )
          {
              if (this.instructorModel.ID !== null && this.instructorModel.ID >= 0) {
                  this.$vs.loading();
                this.$store.dispatch("instructorList/updateItem", this.instructorModel).then(()=>{
                   this.$vs.loading.close();
                }).catch(err => {
             this.$vs.loading.close();
              console.error(err);
            });
                this.$store.state.instructorList.search.pageNum=1;
              this.initValues();
              this.cancle();
              } else {
                  this.$vs.loading();
              this.$store.dispatch("instructorList/addItem", this.instructorModel).then(()=>{
                   this.$vs.loading.close();
              }).catch(err => {
             this.$vs.loading.close();
              console.error(err);
            });
              this.$store.state.instructorList.search.pageNum=1;
                this.initValues();
                this.cancle();
              }
          }
          else{
            this.$vs.dialog({
                color: "warning",
                title: this.$t("CompleteData") ,
              text: this.$t("pleasecompletemandatorydataandatleastoneofeachdatalistandmakesurethatyourcontactcontainyouremail"),

            });
          }

        }
      });
    },

     initValues()
    {
       this.instructorModel = {
        InstructorLanguages:[],
        InstructorContacts:[],
        InstructorEducations:[],
        InstructorCourses:[],
        InstructorAreas:[],
        InstructorIndustrySectors:[],
        Attachments:[],
      }
    },
  },


  created() {
    debugger;
     if(!moduleInstructor.isRegistered) {
      this.$store.registerModule("instructorList", moduleInstructor)
      moduleInstructor.isRegistered = true
    }
    const ID = this.$route.params.ID
     if(ID!=undefined)
     {

      this.$store.dispatch("instructorList/GetItemByID", ID)
      .then(res => {
         this.instructorModel = res.data
      debugger;
       })
      .catch(err => {
         debugger;
        if(err.response.status === 404) {
          this.user_not_found = true
          return
        }
        console.error(err) })
     }
    // Register Module UserManagement Module

    //this.fetch_instructor_data(this.$route.params.userId)
    //this.instructorModel=this.$route.params.data
  }
}

</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
